import type { ExcalidrawImperativeAPI } from "@excalidraw/excalidraw/types";
import type { ExcalidrawElement } from "@excalidraw/excalidraw/element/types";
import {
  canonicalSceneJson,
  fingerprintCollabElements,
  type ExcalidrawSceneData,
} from "@excalidraw-ms/shared";
import { currentSceneVersion, sceneVersion, serializeFromAPI } from "./sceneHelpers";

export function captureCollabSnapshot(api: ExcalidrawImperativeAPI) {
  const scene = JSON.parse(serializeFromAPI(api)) as ExcalidrawSceneData;
  // Native database serialization drops tombstones and rewrites linear fields.
  // A coordinated cloud save must preserve the exact reconciled element set.
  const sceneJson = JSON.stringify({ ...scene, elements: api.getSceneElementsIncludingDeleted() });
  const elements = (JSON.parse(sceneJson) as ExcalidrawSceneData).elements;
  return { sceneJson, elements, version: sceneVersion(elements as ExcalidrawElement[]) };
}

export async function isCurrentCollabSnapshotSaved(
  api: ExcalidrawImperativeAPI,
  savedVersion: number,
  fingerprint?: string,
): Promise<boolean> {
  if (currentSceneVersion(api) > savedVersion) return false;
  if (!fingerprint) return false;
  const captured = canonicalSceneJson(api.getSceneElementsIncludingDeleted());
  const actual = await fingerprintCollabElements(JSON.parse(captured));
  return (
    actual === fingerprint &&
    captured === canonicalSceneJson(api.getSceneElementsIncludingDeleted()) &&
    currentSceneVersion(api) <= savedVersion
  );
}
